import { ColumnConfig, PrincipalReportsColumnKey } from '../../model';

export const cfaOrderReportConfig: Record<
  PrincipalReportsColumnKey,
  ColumnConfig
> = {
  sNo: {
    name: 'S.No',
  },
  orderDate: {
    name: 'Date',
    sortField: 'orderDate',
  },
  productTitle: {
    name: 'Product Title',
    field: 'component',
  },
  skuCode: {
    name: 'SKU Code',
  },
  cfa: {
    name: 'CFAs',
    sortField: 'cfaname',
  },
  orders: {
    name: 'Orders',
    sortField: 'totalorders',
    alignment: 'flex-end',
  },
  orderQty: {
    name: ' Ord. Qty',
    sortField: 'totalqty',
    alignment: 'flex-end',
  },
  orderAmt: {
    name: 'Ord Amt',
    sortField: 'totalvalue',
    alignment: 'flex-end',
  },
  tags: {
    name: 'Tags',
  },
};
